module.exports = __webpack_public_path__ + "media/images/in-their-words-2-fbe452904a9fcf46ca99852987c10195.png";